interface TotalValues {
  tong_sl: number;
  tong_tien_von: number;
  tong_tien: number;
  tong_ck: number;
  tong_thue: number;
  tong_thanh_toan: number;
}

export function calculateTotals(detailItems: BanHangRecord[] = []): TotalValues {
  let tong_sl = 0;
  let tong_tien_von = 0;
  let tong_tien_raw = 0;
  let tong_ck_raw = 0;
  let tong_thue_raw = 0;

  for (const item of detailItems) {
    tong_sl += Number(item.so_luong) || 0;
    tong_tien_von += Number(item.tien_nt) || 0;

    if (item.ct_km == '1') continue;

    const amount = Number(item.tien_nt2) || 0;
    const discount = Number(item.ck_nt) || 0;
    tong_tien_raw += amount - discount;
    tong_ck_raw += discount;
    tong_thue_raw += Number(item.thue_nt) || 0;
  }

  const tong_tien = Math.round(tong_tien_raw * 10) / 10;
  const tong_ck = Math.round(tong_ck_raw * 100) / 100;
  const tong_thue = Math.round(tong_thue_raw * 100) / 100;
  const tong_thanh_toan: number = Math.round(Number(tong_tien + tong_thue) * 100) / 100;

  return { tong_sl, tong_tien_von, tong_tien, tong_ck, tong_thue, tong_thanh_toan };
}

export const handleUpdateRowFields = (
  row: BanHangRecord,
  field: string,
  newValue: BanHangValue,
  globalChietKhau?: number
) => {
  if (
    field === 'so_luong' ||
    field === 'gia_nt2' ||
    field === 'tl_ck' ||
    field === 'ma_thue_data' ||
    field === 'gia_nt' ||
    field === 'ma_vt_data'
  ) {
    let gia_nt = row.gia_nt;
    let gia_nt2 = row.gia_nt2;
    let tl_ck_manual = row.tl_ck_manual;
    let ma_thue_manual = row.ma_thue_manual;
    let gia_nt_manual = row.gia_nt_manual;
    let gia_nt2_manual = row.gia_nt2_manual;
    let ma_thue_data = row.ma_thue_data;

    const so_luong = field === 'so_luong' ? newValue : row.so_luong;

    if (field === 'gia_nt') {
      gia_nt = newValue;
      gia_nt_manual = true;
    } else if (field === 'gia_nt2') {
      gia_nt2 = newValue;
      gia_nt2_manual = true;
    } else if (field === 'ma_vt_data') {
      gia_nt = newValue?.gia_nt || 0;
      gia_nt2 = newValue?.gia_nt2 || 0;
      ma_thue_data = newValue?.ma_thue_data || null;
      gia_nt_manual = false;
      gia_nt2_manual = false;
      ma_thue_manual = false;
      tl_ck_manual = false;
    } else if (field === 'tl_ck') {
      tl_ck_manual = true;
    }

    let tl_ck;
    if (field === 'tl_ck') {
      tl_ck = newValue;
    } else if (tl_ck_manual) {
      tl_ck = row.tl_ck;
    } else if (globalChietKhau !== undefined) {
      tl_ck = globalChietKhau;
    } else {
      tl_ck = row.tl_ck;
    }

    const thue_suat = field === 'ma_thue_data' ? newValue?.thue_suat || 0 : row.ma_thue_data?.thue_suat || 0;

    const tien_nt2 = (Number(so_luong) || 0) * (Number(gia_nt2) || 0);
    const tien_nt = (Number(so_luong) || 0) * (Number(gia_nt) || 0);
    const tien_tck_nt = tien_nt2; // Amount before discount = tien_nt2 for hoa-don-ban-hang
    const ck_nt = (tien_tck_nt * (Number(tl_ck) || 0)) / 100;
    const tien_sau_ck = tien_tck_nt - ck_nt; // Amount after discount
    const thue_nt = (tien_sau_ck * (Number(thue_suat) || 0)) / 100; // Tax on post-discount amount

    return {
      tien_nt2,
      tien_nt,
      tien_tck_nt,
      ck_nt,
      thue_nt,
      tl_ck,
      gia_nt,
      gia_nt2,
      tl_ck_manual,
      ma_thue_manual,
      gia_nt_manual,
      gia_nt2_manual,
      ma_thue_data
    };
  }
  if (field === 'ma_vt_data') {
    return {
      ma_kho_data: newValue?.ma_kho_data || row.ma_kho_data,
      tk_tl_data: newValue?.tk_tl_data || row.tk_tl_data,
      tk_dt_data: newValue?.tk_dt_data || row.tk_dt_data,
      tk_gv_data: newValue?.tk_gv_data || row.tk_gv_data,
      tk_km_data: newValue?.tk_km_data || row.tk_km_data,
      tk_ck_data: newValue?.tk_ck_data || row.tk_ck_data,
      tk_khcp_data: newValue?.tk_khcp_data || row.tk_khcp_data
    };
  }
  return {};
};

export const recalculateWithNewChietKhau = (row: BanHangRecord, newChietKhau: number) => {
  const so_luong = row.so_luong || 0;
  const gia_nt = row.gia_nt || row.ma_vt_data?.gia_nt || 0;
  const gia_nt2 = row.gia_nt2 || row.ma_vt_data?.gia_nt2 || 0;
  const thue_suat = row.ma_thue_data?.thue_suat || row.ma_vt_data?.ma_thue_data?.thue_suat || 0;

  const tien_nt2 = (Number(so_luong) || 0) * (Number(gia_nt2) || 0);
  const tien_nt = (Number(so_luong) || 0) * (Number(gia_nt) || 0);
  const tien_tck_nt = tien_nt2; // Amount before discount
  const ck_nt = (tien_tck_nt * (Number(newChietKhau) || 0)) / 100;
  const tien_sau_ck = tien_tck_nt - ck_nt; // Amount after discount
  const thue_nt = (tien_sau_ck * (Number(thue_suat) || 0)) / 100; // Tax on post-discount

  return {
    tl_ck: newChietKhau,
    ck_nt,
    tien_nt2,
    tien_nt,
    tien_tck_nt,
    thue_nt
  };
};
